import type { ExpressionSpecification } from 'mapbox-gl';

/**
 * Zoom-based expressions to keep map overlays (stations, labels) proportional
 * to the map scale. Smaller when zoomed out, full size when zoomed in.
 */

/** Circle radius: 5 at zoom 9, 12 at zoom 18 (larger default, still scales with zoom) */
export const ZOOM_CIRCLE_RADIUS: ExpressionSpecification = [
  'interpolate',
  ['linear'],
  ['zoom'],
  9,
  5,
  12,
  7,
  15,
  9,
  18,
  12,
];

/** Text size for station labels: 10 at zoom 9, 14 at zoom 18 (larger default) */
export const ZOOM_STATION_LABEL_SIZE: ExpressionSpecification = [
  'interpolate',
  ['linear'],
  ['zoom'],
  9,
  10,
  12,
  11,
  15,
  12,
  18,
  14,
];

/** Text size for wind speed labels: 12 at zoom 9, 16 at zoom 18 (larger default) */
export const ZOOM_WIND_LABEL_SIZE: ExpressionSpecification = [
  'interpolate',
  ['linear'],
  ['zoom'],
  9,
  12,
  12,
  13,
  15,
  14,
  18,
  16,
];
